// extracted by mini-css-extract-plugin
export default {"input_container":"InputBoxCurrencyAlternative_input_container__cdQwi","label":"InputBoxCurrencyAlternative_label__1oenI","input":"InputBoxCurrencyAlternative_input__QYpg8"};